
<template>
  <card id="popover-card" context="info" v-show="popper">
    <font-awesome-icon icon="times-circle" class="popover-icon" @click="closePopper"/>
    <div class="custom-control custom-checkbox mb-2">
      <input
        type="checkbox"
        class="custom-control-input"
        id="checkEnable"
        v-model="sensorSelecionado.sensorConfiguration.enabled"
      >
      <label class="custom-control-label" for="checkEnable">Ativado</label>
    </div>
    <div class="form-group">
      <label
        v-if="sensorSelecionado.sensorDescription == 'TemperatureSensor'"
      >Setar valor de limite:
        <br>
        <input type="number" v-model="sensorSelecionado.sensorConfiguration.act" id>
      </label>
      <label v-else-if="sensorSelecionado.sensorDescription != 'MovementSensor'">
        Modo de contato:
        <select
          v-model="sensorSelecionado.sensorConfiguration.act"
          class="custom-select"
        >
          <option value="0">NA</option>
          <option value="1">NF</option>
        </select>
      </label>
      <br>
      <button id="btn-set" class="btn btn-secondary mt-2" @click="sendSensorParameter">Setar</button>
    </div>
  </card>
</template>

<script>
import Popper from "popper.js";
import API from "../../utils/api";
import Card from "../resources/Card";
import { mapState } from "vuex";
let $api = new API();

export default {
  name: "PopoverSet",
  data() {
    return {
      popper: false,
      sensorSelecionado: { sensorConfiguration: {} }
    };
  },
  created() {
    this.$root.$on("show-popper", (event, sensor) => {
      this.sensorSelecionado = JSON.parse(JSON.stringify(sensor));
      this.showPopper(event, sensor);
    });
  },
  methods: {
    sendSensorParameter() {
      this.$emit("processing", true);
      $api
        .sendSensorParameter(this.sheriff.id.address, this.sensorSelecionado)
        .catch(e => {
          if (e.response.status == 401)
            this.$router.push({ path: "/login", query: { to: "/" } });
        })
        .then(() => {
          this.closePopper();
        })
        .finally(() => {
          this.$emit("processing", false);
        });
    },
    showPopper(event) {
      if (this.popper) {
        this.closePopper();
      }
      this.popper = new Popper(event.target, this.$el, {
        placement: "right"
      });
    },
    closePopper() {
      this.popper.destroy();
      this.popper = false;
    }
  },
  computed: {
    ...mapState(["sheriff"])
  },
  components: {
    Card
  }
};
</script>

<style>
.popover-icon {
  position: absolute;
  right: 4px;
  top: 4px;
  cursor: pointer;
}
</style>
